
<template>

<Chips v-model="value" separator="," />
 
</template>

<script>
import { abstractField } from "vue-form-generator";

export default {
  mixins: [abstractField],
};
</script>